<div #chartContainer id="chartContainer" style="height: 300px"></div>
